import { useCallback } from 'react';
import { DirectoryUsersGrid } from '@jarvis/platform-ui';
import { fetchCeClientAccessSyncStatus, listCeClientAccessUsers } from '../../api/directoryUsers';

export function CeClientAccessPage() {
  const loadPage = useCallback(
    (request: Parameters<typeof listCeClientAccessUsers>[0]) => listCeClientAccessUsers(request),
    []
  );

  return (
    <div className="ops-fill-page ops-fill-page--bare">
      <div className="ops-fill-page__grid-host">
        <DirectoryUsersGrid
          loadPage={loadPage}
          loadSyncStatus={fetchCeClientAccessSyncStatus}
          showTenantColumn
          stateStorageKey="webopsui:ce-client-access-grid:v5"
        />
      </div>
    </div>
  );
}
